/*
  Add here your own custom javascript codes
*/

// JS to trigger animation when in view
document.addEventListener("DOMContentLoaded", function () {
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("animate__fadeIn");
        entry.target.classList.add("animate__fadeInDown");
        entry.target.classList.add("animate__fadeInUp");
        entry.target.classList.add("animate__slideInUp");
        entry.target.classList.add("animate__slideInRight");
        entry.target.classList.add("animate__slideInLeft");
        entry.target.classList.add("animate__zoomIn");
        
        
        entry.target.style.opacity = 1; // Make it visible
        observer.unobserve(entry.target); // Only animate once
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.animate-on-scroll').forEach(el => {
    observer.observe(el);
  });
});
